import { io } from "socket.io-client";
import store from "@/store";

const socket = {
  io: null,
  messageQueue: [],
  isClosed: false,
  reconnectAttempts: 0,
  maxReconnectAttempts: 10,

  init() {
    return new Promise((resolve, reject) => {
      try {
        const {
          VUE_APP_API_URL: apiUrl,
          VUE_APP_WS_PORT: port,
          VUE_APP_WS_PATH: path
        } = process.env;

        const url = new URL(apiUrl);
        const protocol = url.protocol === "https:" ? "wss" : "ws";
        const isProd = process.env.NODE_ENV === "production";
        const socketUrl = isProd
          ? `${protocol}://${url.hostname}`
          : `${protocol}://${url.hostname}:${port}`;

        this.io = io(socketUrl, {
          path: `/${path}`,
          transports: ["websocket"],
          reconnectionAttempts: this.maxReconnectAttempts
        });

        this.io.on("connect", () => {
          this.reconnectAttempts = 0;
          this.isClosed = false;
          this.processMessageQueue();
          resolve();
        });

        this.io.on("connect_error", err => {
          console.error("Socket.IO connect error:", err);
          reject(err);
        });

        this.io.on("disconnect", reason => {
          console.log("Socket.IO disconnected:", reason);
        });

        this.io.onAny((event, payload) => {
          this.handleMessage({ action: event, ...payload });
        });
      } catch (error) {
        console.error("Помилка ініціалізації Socket.IO:", error);
        reject(error);
      }
    });
  },

  process(msg) {
    if (this.io && this.io.connected) {
      if (
        msg.action === "auth" &&
        typeof msg.data === "object" &&
        msg.data !== null &&
        Object.keys(msg.data).length === 0
      ) {
        return;
      }
      this.io.emit("message", msg);
    } else {
      this.messageQueue.push(msg);
      console.log("Socket.IO не з'єднано, повідомлення в черзі.");
    }
  },

  processMessageQueue() {
    const { accessToken, _id } = store.getters.gerUser || {};

    if (accessToken) {
      this.io.emit("message", {
        action: "auth",
        data: { userId: _id, token: accessToken }
      });
    }

    while (this.messageQueue.length > 0) {
      const msg = this.messageQueue.shift();
      this.io.emit("message", msg);
    }
  },

  destroy() {
    if (this.io) {
      this.io.disconnect();
      this.io = null;
      this.isClosed = true;
    }
  },

  handleMessage(msg) {
    const result = msg.result;
    console.log(msg);
    switch (msg.action) {
      case "subscribed":
        console.log("subscribed - " + msg.channel);
        break;
      case "general":
        store.commit("UPDATE_MATCHS_GENERAL_DATA", msg.data);
        break;
      case "odds-tiker":
        store.commit("SET_MATCH_ODDS", msg.data);
        break;
      case "auth error":
        console.log("auth error =", msg.message);
        break;
      case "pre-count":
        store.commit("SET_PREMATCH_COUNT", msg.data);
        break;
      case "UserSubscription":
        break;
      case "update":
        store.dispatch("updateDadbeeMatches", msg);
        break;
      case "forecast":
        store.dispatch("getDadbeeForecast");
        break;
      case "reset":
        store.dispatch("fetchDadbeeMatches", result === false ? [] : result);
        break;
      default:
        console.warn("Невідома дія:", msg.action);
    }
  }
};

export default socket;
